import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUserFromCallback } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sid = params.get('session_id');
    (async () => {
      if (!sid) { navigate('/login'); return; }
      try {
        const { data } = await api.post('/auth/google-session', { session_id: sid });
        setUserFromCallback(data.user);
        navigate('/account', { state: { user: data.user } });
      } catch {
        navigate('/login?error=google');
      }
    })();
  }, [navigate, setUserFromCallback]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <p className="text-[11px] tracking-widest-plus uppercase text-[#1a1a1a]/60">Signing you in…</p>
    </div>
  );
}
